import { ApolloClient, InMemoryCache } from '@apollo/client'

export const client = new ApolloClient({
  cache: new InMemoryCache(),
  // uri: "http://localhost:6021/graphql/",
  uri: `${process.env.REACT_APP_BACKEND_API_URL}/graphql/`
  // uri: "https://countries.trevorblades.com/",
})
